export const MentorshipParticipantRoles = Object.freeze({
  MENTOR: "mentor",
  MENTEE: "mentee",
});
